import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function CTASection({
  title = "Ready to build your team?",
  copy = "Tell us what you need and we'll help you determine the right people, structure and delivery model for your business.",
}) {
  return (
    <section data-testid="cta-section" className="relative overflow-hidden py-16 sm:py-24">
      <div className="spotlight absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <h2 className="font-display text-2xl font-bold leading-snug tracking-tight text-white sm:text-3xl lg:text-4xl">
            {title}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-mist sm:text-lg">{copy}</p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/get-your-team"
              data-testid="cta-build-your-team"
              className="group flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-3.5 text-sm font-semibold text-ink transition-colors hover:bg-brand-bright"
            >
              Build Your Team
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
            <Link
              to="/contact"
              data-testid="cta-talk-to-us"
              className="flex items-center justify-center rounded-full border border-white/15 px-7 py-3.5 text-sm font-semibold text-slate-200 transition-colors hover:border-brand/50 hover:text-white"
            >
              Talk to Us
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
